export const tag = {
  colorScheme: {
    dark: {
      primary: {
        color: '{surface.0}',
      },
    },
  },
}
